import type {
    BootstrapCommerceContextResponse,
    CommerceContext,
    CommerceSession,
} from "@teqtank/commerce-contracts";
import type { CommerceTransport } from "@teqtank/commerce-transport";
import { CommerceError } from "../errors/commerce-error.js";
import { bootstrapCommerceContextOperation } from "../operations/bootstrap-commerce-context-operation.js";
import { resolveCommerceContext } from "./resolve-commerce-context.js";

export async function bootstrapCommerceContext(
    transport: CommerceTransport,
    session: CommerceSession,
    correlationId: string,
): Promise<CommerceContext> {
    let response: BootstrapCommerceContextResponse;

    try {
        response = await transport.execute(
            bootstrapCommerceContextOperation,
            {
                sessionToken: session.token,
                commerceKey: session.commerceKey,
            },
            {
                correlationId,
                commerceKey: session.commerceKey,
                dataSource: session.dataSource,
            },
        );
    } catch (cause) {
        throw new CommerceError(
            "context-bootstrap-failed",
            "Teqtank Commerce could not resolve the Commerce runtime context.",
            {
                commerceKey: session.commerceKey,
                transportName: transport.name,
                correlationId,
                cause,
            },
        );
    }

    return resolveCommerceContext(response, session);
}
